import(/* webpackMode: "eager", webpackExports: ["BshbPortalVideo"] */ "/vercel/path0/apps/www/src/app/(mkt)/footer/portal-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LightHeader"] */ "/vercel/path0/apps/www/src/components/mkt/header/light.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/vercel/path0/apps/www/src/components/mkt/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/vercel/path0/apps/www/src/sotano-kit/primitives/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/basehub@9.5.3_@babel+runtime@7.28.2_@types+react@19.0.12_react@19.1.2/node_modules/basehub/dist/client-pump-J7K23F3Q.js");
